import Component from "@glimmer/component";
import { service } from "@ember/service";
import { modifier } from "ember-modifier";
import deprecated from "discourse-common/lib/deprecated";
import { precompileTemplate } from "@ember/template-compilation";
import { setComponentTemplate } from "@ember/component";
export default class DPopover extends Component {
  static {
    dt7948.g(this.prototype, "tooltip", [service]);
  }
  #tooltip = (dt7948.i(this, "tooltip"), void 0);
  registerDTooltip = modifier(element1 => {
    deprecated("`<DPopover />` is deprecated. Use `<DTooltip />` or the `tooltip` service instead.", {
      id: "discourse.d-popover"
    });
    const trigger1 = element1.children[0];
    const content1 = element1.children[1];
    if (!trigger1 || !content1) {
      return;
    }
    const instance1 = this.tooltip.register(trigger1, {
      content: content1
    });
    content1.remove();
    return () => {
      instance1.destroy();
    };
  });
  static {
    setComponentTemplate(precompileTemplate("\n    <div style=\"display:inline-flex;\" {{this.registerDTooltip}}>\n      {{yield}}\n    </div>\n  ", {
      strictMode: true
    }), this);
  }
}